import { Component, Input, OnDestroy } from '@angular/core';
import { TranslatorService } from '../../../services/translator_service';
import { ResponsiveService } from '../../../services/responsive.service';
import { ApiQuery } from '../../../web-services/api/api.query';
import { ApiService } from '../../../web-services/api/api.service';
import _ from 'lodash';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-bin-events',
  standalone: true,
  imports: [CommonModule,TranslateModule,RTLDivDirectiveDirective],
  templateUrl: './bin-events.component.html',
  styleUrl: './bin-events.component.scss'
})
export class BinEventsComponent implements OnDestroy {
	isMobile: boolean;
	translationsObj;
	currentLang;
  binEvents: Array<any> = [];
  binEventsBackUp: Array<any> = [];
	private readonly destroy$ = new Subject<void>();

	constructor(private translator: TranslatorService,private responsiveService: ResponsiveService,private apiQuery: ApiQuery,
    private apiService:ApiService) {
    this.translator.currentLangEmitter$
    .pipe(takeUntil(this.destroy$))
    .subscribe(async value=>{						
      this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
      this.currentLang = value;
    })
  }

  ngOnInit() {
    this.onResize();
    this.responsiveService.checkWidth();

    this.apiQuery.binEvents$.pipe(takeUntil(this.destroy$)).subscribe((binEvents) => {		
			this.binEvents = binEvents;
      this.binEventsBackUp = binEvents;
		});
  }

  onResize() {
    this.responsiveService.getMobileStatus().pipe(takeUntil(this.destroy$)).subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

  removeBinEvent = (index) => {
		const binToRemove = this.binEvents[index].event_id;
		this.binEvents.splice(index, 1);
		this.apiService.removeBinEvents({ 'event_id_list': [binToRemove] }).pipe(takeUntil(this.destroy$)).subscribe((v:any) => {});
	}

	clearAllBinEvents = () => {
		const tempArray = _.map(this.binEvents, 'event_id');
		this.apiService.removeBinEvents({ 'event_id_list': tempArray }).pipe(takeUntil(this.destroy$)).subscribe((v:any) => {});
		this.binEvents = [];
	}

  validateDateIw(param: any){
    return moment(param).format('MMM DD, HH:mm');
  }

  validateDateEn(param: any){
    return moment(param).format('MMM DD, hh:mm A');
  }

  applyFilter(target: any){
    const value = target.value;
    this.binEvents = this.binEventsBackUp.filter(binEvent => binEvent.event_body.toLowerCase().includes(value.toLowerCase()) ||
      binEvent.event_body_hebrew.toLowerCase().includes(value.toLowerCase()) || binEvent.event_id.toString().toLowerCase().includes(value.toLowerCase()));
  }
}
